import script from "./Payees.vue?vue&type=script&lang=ts&setup=true"
export * from "./Payees.vue?vue&type=script&lang=ts&setup=true"

import "./Payees.vue?vue&type=style&index=0&id=7b40c7b3&lang=scss"

const __exports__ = script;

export default __exports__